export const enum EMagnitudeType {
  RMS = 'RMS',
  POWER = 'POWER'
}
